import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { LocationStrategy } from '@angular/common';
import { IBaseModel } from '../models/base.model';
import { INiveisRiscoInerente } from '../models/niveis-risco-inerente.model';

@Injectable({
  providedIn: 'root'
})
export class NiveisRiscoInerenteService extends BaseService {


  constructor(httpClient: HttpClient, locationStrategy: LocationStrategy) {
    super(httpClient, locationStrategy);
  }

  public obter(criteriosAvaliacaoRiscosId: string, ativo: boolean, simplificado = false): Promise<IBaseModel<INiveisRiscoInerente[]>> {
    let params = new HttpParams();
    params = params.append('criteriosAvaliacaoRiscosId', criteriosAvaliacaoRiscosId || '0');

    if (ativo !== undefined) {
      params = params.append('ativo', ativo.toString());
    }

    if (simplificado) {
      params = params.append('simplificado', simplificado.toString());
    }

    return this.httpClient
      .get<IBaseModel<INiveisRiscoInerente[]>>(`${this.apiBaseUrl}/niveisRiscoInerente`, { params })
      .toPromise();
  }

  public async obterPorId(id: number): Promise<IBaseModel<INiveisRiscoInerente>> {
    return this.httpClient
      .get<IBaseModel<INiveisRiscoInerente>>(`${this.apiBaseUrl}/niveisRiscoInerente/${id}`)
      .toPromise();
  }

  public async inserir(data: INiveisRiscoInerente): Promise<IBaseModel<void>> {
    return this.httpClient
      .post<IBaseModel<void>>(`${this.apiBaseUrl}/niveisRiscoInerente`, data)
      .toPromise();
  }

  public async atualizar(data: INiveisRiscoInerente): Promise<IBaseModel<void>> {
    return this.httpClient
      .put<IBaseModel<void>>(`${this.apiBaseUrl}/niveisRiscoInerente/${data.id}`, data)
      .toPromise();
  }

  public async excluir(id: number): Promise<IBaseModel<void>> {
    return this.httpClient
      .delete<IBaseModel<void>>(`${this.apiBaseUrl}/niveisRiscoInerente/${id}/excluir`, {})
      .toPromise();
  }
}